import { motion } from "framer-motion";
import { Tag, Receipt, MessagesSquare } from "lucide-react";
import { staggerParent, staggerChild } from "@/components/Motion";

const ITEMS = [
  { icon: Tag, t: "Your car, your price", d: "You set the price and keep the full amount. No commission, ever." },
  { icon: Receipt, t: "One flat listing fee", d: "Pay once for the weeks you need, or a simple monthly plan." },
  { icon: MessagesSquare, t: "Talk directly to sellers", d: "Message the owner on Vorra. No middlemen, no call centres." },
];

export function TrustStrip() {
  return (
    <section className="relative z-10 -mt-14 max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-testid="trust-strip">
      <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
        className="grid md:grid-cols-3 bg-white rounded-2xl border border-navy/10 shadow-[0_30px_60px_-30px_rgba(22,36,47,0.35)] divide-y md:divide-y-0 md:divide-x divide-navy/10">
        {ITEMS.map((it, i) => (
          <motion.div key={it.t} variants={staggerChild} className="p-6 lg:p-8 flex gap-4" data-testid={`trust-item-${i}`}>
            <div className="w-11 h-11 rounded-xl bg-teal-tint flex items-center justify-center shrink-0"><it.icon className="w-5 h-5 text-teal" /></div>
            <div>
              <h3 className="font-heading font-bold text-navy text-lg">{it.t}</h3>
              <p className="text-sm text-slatev mt-1">{it.d}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
